import PagesContentEdit from "./PagesContentEdit"
import PagesContentList from "./PagesContentList"

const PagesContentCRUD = {
  edit: PagesContentEdit,
  list: PagesContentList,
}

export default PagesContentCRUD
